<template>
  <div class="div-card">
    <div class="div-card-content">
      <p class="number mb-0 mt-12">{{ openComplaints }}</p>
      <p class="label">pending complaints</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['openComplaints']
}
</script>

<style scoped>
.v-card__title {
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: dimgray;
}
.div-card {
  padding-top: 100%;
}
.div-card-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
p.label {
  color: #f87979;
  text-align: center;
}
p.number {
  text-align: center;
  font-size: 90px;
  font-weight: bold;
  color: #f87979;
  line-height: 100px;
}
</style>
